import type {PermissionType} from '@hconnect/apiclient'

export const ALL_FREQUENCIES = 'all'

export const JTBD_PERMISSIONS: PermissionType[] = [
  'EDIT_MAJOR_OUTAGE_LEAD_JTBD',
  'EDIT_OPTIMIZATION_SPECIALIST_JTBD',
  'EDIT_PROCESS_ENGINEER_JTBD',
  'EDIT_QUALITY_ENGINEER_JTBD',
  'EDIT_RELIABILITY_ENGINEER_JTBD',
  'EDIT_SYSTEM_ENGINEER_JTBD',
  'EDIT_REGIONAL_MANAGER_JTBD'
]
